import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiHalfsmileFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 1.333C3.167 1.333 1.334 3.167 1.334 16S3.167 30.667 16 30.667 30.667 28.833 30.667 16 28.833 1.333 16 1.333m-1.792 20.779c-.24-.255-.341-.524-.341-.779h-2.4c0 .947.394 1.785.991 2.422.86.914 2.157 1.445 3.542 1.445 1.386 0 2.683-.53 3.542-1.445.598-.637.991-1.475.991-2.422h-2.4c0 .255-.101.524-.34.779-.358.38-.997.688-1.793.688s-1.434-.307-1.792-.688m4.126-9.445c0-1.167.583-2.334 2.333-2.334S23 11.5 23 12.667C23 13.833 22.417 15 20.667 15s-2.334-1.167-2.334-2.333m-7-2.334C9.584 10.333 9 11.5 9 12.667 9 13.833 9.584 15 11.334 15s2.333-1.167 2.333-2.333-.583-2.334-2.333-2.334"
            fill="currentColor"
        />
    </svg>
));
EmojiHalfsmileFilledSize32Glyph.displayName = 'EmojiHalfsmileFilledSize32Glyph';
